import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { PersonDataDto } from '../../shared/types/PersonDataDto';

@Component({
  selector: 'lp2-mid-level-exam-modal',
  templateUrl: './mid-level-exam-modal.component.html',
  styleUrls: ['./mid-level-exam-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MidLevelExamModalComponent implements OnInit {
  public person: PersonDataDto;

  constructor(private oeAppPersonService: OeAppPersonService, private activeModal: NgbActiveModal) {}

  ngOnInit() {
    this.person = this.oeAppPersonService.getPersonData();
  }

  public onStart() {
    this.activeModal.close(true);
  }

  public onSkip() {
    this.activeModal.close(false);
  }
}



// WEBPACK FOOTER //
// ./ts/app/learning/mid-level-exam-modal/mid-level-exam-modal.component.ts